import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Table } from 'react-bootstrap';
import FixedRecordRow from './fixed_record_row';

import { handleToggleSkipAllRecords } from '../store/actions/run_records';
import { recordStatuses } from '../import_constants';

export class FixedRecordsTable extends React.Component {
  static propTypes = {
    allRecordsSelected: PropTypes.bool,
    currentStep: PropTypes.string.isRequired,
    recordIds: PropTypes.array.isRequired,
    records: PropTypes.object.isRequired,
    onToggleSkipAllRecords: PropTypes.func.isRequired
  }

  previewStep = () => this.props.currentStep === "preview";

  allValidImports = () => {
    return Object.values(this.props.records).every((record) => {
      return record.previewStatus === recordStatuses["success"];
    });
  }

  renderFixedCells() {
    const { recordIds, records } = this.props;
    const allValidImports = this.allValidImports();

    return recordIds.map((id) => {
      return (
        <FixedRecordRow
          allValidImports={allValidImports}
          key={id}
          record={records[id]}
        />
      );
    });
  }

  renderHeaders() {
    const { allRecordsSelected, onToggleSkipAllRecords } = this.props;
    const allValidImports = this.allValidImports();

    return (
      <React.Fragment>
        <th className="table-cell text-center">#</th>
        {this.previewStep()
          ? (
            <React.Fragment>
              <th className="table-cell">
                <input
                  checked={allRecordsSelected}
                  className="checkbox--lg"
                  name="toggle-skip-all"
                  type="checkbox"
                  onChange={() => onToggleSkipAllRecords()}
                />
              </th>
              {!allValidImports && <th className="table-cell"></th>}
            </React.Fragment>
          )
          : (
            <React.Fragment>
              <th className="table-cell">Action</th>
              <th className="table-cell"></th>
            </React.Fragment>
          )
        }
      </React.Fragment>
    );
  }

  render() {
    return (
      <div className="fixed-table-container">
        <Table className="records-table mb-0">
          <thead className="records-header">
            <tr>
              {this.renderHeaders()}
            </tr>
          </thead>
          <tbody className="records-body">
            {this.renderFixedCells()}
          </tbody>
        </Table>
      </div>
    );
  }
}


const mapStateToProps = state => ({
  allRecordsSelected: state.runRecords.meta.allRecordsSelected,
  currentStep: state.ui.currentStep,
  recordIds: state.runRecords.recordIds,
  records: state.runRecords.records
});


const mapDispatchToProps = {
  onToggleSkipAllRecords: handleToggleSkipAllRecords,
};

export default connect(mapStateToProps, mapDispatchToProps)(FixedRecordsTable);
